import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="PWA Weather App" link="https://jaykeeshow.github.io/PWA/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a PWA built with React, Rest Api, and it was a great experience. Third part API's from Openweathermap.
    </ProjectCard>
    <ProjectCard title="PWA To-do list App" link="https://jaykeeshow.github.io/toDoList/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is another PWA built with React, React hooks, and simple CSS. Lighthouse audit confirmed Progressive Web App.
    </ProjectCard>
    <ProjectCard title="Login-Form App" link="https://jaykeeshow.github.io/my-app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is a login Auth page / message App created using FakeApi's and React hooks. My first app 
    </ProjectCard>
    <ProjectCard title="App in progress" link="" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
I am working on an eCommerce project in React. Will update my portfolio as soon as it's done.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      